import React from 'react';
import { Moon, Sun, User as UserIcon, LogIn, Menu, CheckCircle2 } from 'lucide-react';
import useAppStore from '../stores/useAppStore';
import { useApp } from '../contexts/AppContext';
import { useAuth } from '../contexts/AuthContext';

export default function AppHeader() {
  const { dispatch } = useApp();
  const { isAuthenticated, openAuthModal } = useAuth();
  const nightMode = useAppStore((s) => s.nightMode);
  const toggleNightMode = useAppStore((s) => s.toggleNightMode);

  return (
    <header className="sticky top-0 z-30 safe-area-top bg-white/90 dark:bg-night-bg/90 backdrop-blur border-b border-gray-100 dark:border-night-card">
      <div className="flex items-center justify-between px-4 h-12 md:pl-6">
        <div className="flex items-center gap-2 min-w-0">
          <button
            type="button"
            className="md:hidden p-1 -ml-1 rounded text-gray-700 dark:text-night-text hover:bg-gray-100 dark:hover:bg-night-card"
            aria-label="Open menu"
            onClick={() => dispatch({ type: 'TOGGLE_SIDEBAR' })}
          >
            <Menu size={20} />
          </button>
          {/* Brand wordmark (the in-view hero title gives view context) */}
          <span className="md:hidden flex items-center gap-1.5 text-sm font-semibold text-gray-900 dark:text-night-text">
            <CheckCircle2 size={16} className="text-accent dark:text-accent-dark" />
            Molehill
          </span>
        </div>
        <div className="flex items-center gap-1">
          <button
            type="button"
            className="p-2 rounded-full text-gray-700 dark:text-night-text hover:bg-gray-100 dark:hover:bg-night-card"
            aria-label={nightMode ? 'Switch to light mode' : 'Switch to dark mode'}
            onClick={toggleNightMode}
          >
            {nightMode ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button
            type="button"
            className="p-2 rounded-full text-gray-700 dark:text-night-text hover:bg-gray-100 dark:hover:bg-night-card"
            aria-label={isAuthenticated ? 'Profile' : 'Sign in'}
            onClick={() =>
              isAuthenticated
                ? dispatch({ type: 'SET_ACTIVE_VIEW', payload: 'profile' })
                : openAuthModal()
            }
          >
            {isAuthenticated ? <UserIcon size={18} /> : <LogIn size={18} />}
          </button>
        </div>
      </div>
    </header>
  );
}
